const features = [
  {
    icon: 'ri-git-merge-line',
    title: 'Dakikalar İçinde Geçiş',
    desc: 'Entegre değişim bloku izleme teknolojisiyle yüzlerce VM\'i saniyeler içinde taşıyın. Hızlı geçiş. Uzun bakım pencereleri yok.',
  },
  {
    icon: 'ri-server-line',
    title: 'Mevcut Sunucularınızı Kullanın',
    desc: 'Forklift yükseltmesi gerekmez. VergeOS, mevcut sunucularınızda çalışır; kullanım ömrünü uzatır ve sermaye harcamalarını ortadan kaldırır.',
  },
  {
    icon: 'ri-cpu-line',
    title: 'RAM\'i Optimize Edin',
    desc: 'RAM süper döngüsünden kaçının. Diğer Platformlara kıyasla VM başına %50 daha az RAM. Hypervisor seviyesinde tekilleştirilmiş depolama önbelleği. VM başına RAM önbelleği gerekmez.',
  },
  {
    icon: 'ri-database-line',
    title: 'Global Tekilleştirme',
    desc: 'Depolama, VM\'ler, RAM ve yedeklemeler genelinde altyapı çapında satır içi global tekilleştirme; performans etkisi olmadan kapasiteyi 4 kata kadar azaltır.',
  },
  {
    icon: 'ri-layout-grid-line',
    title: 'Sanal Veri Merkezleri',
    desc: 'İş yüklerini, müşterileri veya ortamları güvenli, iç içe çok kiracılı yapıyla izole edin; her biri ayrılmış işlem, depolama ve ağ kaynaklarına sahiptir.',
  },
  {
    icon: 'ri-virus-line',
    title: 'Fidye Yazılımı Koruması',
    desc: 'Sınırsız değiştirilemez anlık görüntü oluşturun. Şifreleme yayılmadan önce anomalileri tespit edin. Tüm veri merkezlerini dakikalar içinde kurtarın.',
  },
];

export default function WhyVergeSection() {
  return (
    <section className="bg-white py-16 px-6 border-b border-gray-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <p className="text-xs font-bold text-[#e8600a] uppercase tracking-widest mb-2">Neden VergeOS?</p>
          <h2 className="text-3xl font-bold text-[#1a1a2e] mb-3">Farklı Tasarlandı. Katman Yok.</h2>
          <p className="text-sm text-[#64748b] max-w-lg mx-auto">
            VergeOS; tek bir entegre işletim sistemi.<br />
            Ayrı lisans yok. Karmaşık entegrasyon yok. Satıcı bağımlılığı yok.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f) => (
            <div
              key={f.title}
              className="bg-[#f8fafc] border border-gray-100 rounded-lg p-6 hover:border-orange-200 transition-colors"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-orange-50 rounded-lg mb-4">
                <i className={`${f.icon} text-xl text-[#e8600a]`}></i>
              </div>
              <h3 className="text-sm font-bold text-[#1a1a2e] mb-2">{f.title}</h3>
              <p className="text-xs text-[#64748b] leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
